import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "../components/ui/input";
import { MarkdownCell, CodeCell, Stream } from "../components/Cell";
import { ReviewCard } from "../components/ReviewCard";
import { getReviewQueue, errMsg } from "../lib/api";

const STATUSES = ["pending", "reviewed", "all"];

export default function ReviewPage({ onOpen, active, onCounts }) {
  const [status, setStatus] = useState("pending");
  const [data, setData] = useState(null);
  const [reviewer, setReviewer] = useState(() => localStorage.getItem("moth_reviewer") || "");
  const load = useCallback(() => getReviewQueue(status).then((d) => { setData(d); onCounts?.(d.counts); }).catch((e) => toast.error(errMsg(e))), [status, onCounts]);
  useEffect(() => { if (active) load(); }, [load, active]);
  useEffect(() => { localStorage.setItem("moth_reviewer", reviewer); }, [reviewer]);

  const c = data?.counts || {};
  return (
    <div>
      <MarkdownCell>
        <h1>Expert review queue</h1>
        <p>Every identification the model <b>abstained</b> on lands here. An expert confirms the species (or marks it unidentifiable); confirmed labels become <code>true_label</code> with <code>label_source="expert"</code> and immediately count in the evaluation metrics.</p>
      </MarkdownCell>
      <CodeCell n={1} testid="review-filter-cell" code={`queue = db.identifications.find({"uncertain": True, "review": ${status === "pending" ? '{"$exists": False}' : status === "reviewed" ? '{"$exists": True}' : "..."}})\nreviewer = "${reviewer || "anonymous"}"`}>
        <div className="flex flex-wrap items-center gap-3">
          <div className="flex rounded border overflow-hidden" role="tablist">
            {STATUSES.map((s) => (
              <button key={s} data-testid={`review-status-${s}`} onClick={() => setStatus(s)} className={`px-3 py-1.5 text-xs font-mono transition-colors ${status === s ? "bg-primary text-primary-foreground" : "hover:bg-secondary"}`}>
                {s}{s !== "all" && ` (${c[s] ?? 0})`}
              </button>
            ))}
          </div>
          <label className="flex items-center gap-2 text-xs font-mono">reviewer =
            <Input data-testid="review-reviewer-input" value={reviewer} onChange={(e) => setReviewer(e.target.value)} placeholder="your name" className="h-8 w-44 text-sm" />
          </label>
        </div>
        <Stream testid="review-counts">{`pending  : ${c.pending ?? 0}\nreviewed : ${c.reviewed ?? 0}`}</Stream>
      </CodeCell>
      <CodeCell n={2} testid="review-list-cell" code={"for item in queue:\n    expert.review(item)"}>
        {!data ? <Stream>loading…</Stream> : data.items.length === 0 ? (
          <Stream testid="review-empty">{status === "pending" ? "Queue is empty: no abstained identifications waiting for review." : "Nothing here yet."}</Stream>
        ) : (
          <div className="space-y-3" data-testid="review-list">
            {data.items.map((it, i) => <ReviewCard key={it.id} item={it} idx={i} reviewer={reviewer} onDone={load} onOpen={onOpen} />)}
          </div>
        )}
      </CodeCell>
    </div>
  );
}
